// src/services/authService.js
// 認証関連

import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPhoneNumber,
  RecaptchaVerifier,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { auth } from '../config/firebase';
import { createUser } from './userService';
import { createChatRoom } from './chatService';

// ── 電話番号認証（メイン：ユーザー向け） ──
export function setupRecaptcha(elementId) {
  return new RecaptchaVerifier(auth, elementId, {
    size: 'invisible',
  });
}

export async function sendPhoneVerification(phoneNumber, recaptchaVerifier) {
  const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier);
  return confirmationResult;
}

export async function verifyPhoneCode(confirmationResult, code) {
  const result = await confirmationResult.confirm(code);
  return result.user;
}

// ── メール認証（スタッフ管理画面向け） ──
export async function staffSignIn(email, password) {
  const result = await signInWithEmailAndPassword(auth, email, password);
  return result.user;
}

export async function createStaffAccount(email, password) {
  const result = await createUserWithEmailAndPassword(auth, email, password);
  return result.user;
}

// ── ユーザー登録フロー（オンボーディング完了後） ──
export async function completeUserRegistration(uid, userData) {
  await createUser(uid, userData);
  await createChatRoom(uid);
}

// ── ログアウト ──
export async function logout() {
  await signOut(auth);
}

// ── 認証状態の監視 ──
export function onAuthChange(callback) {
  return onAuthStateChanged(auth, callback);
}
